import React, { createContext, useContext, useEffect, useState } from 'react';
import { isDarkMode } from '../lib/theme';
import { CUSTOM_EVENTS } from '../utils/constants';

/**
 * ThemeContext provides theme state across the app
 */
const ThemeContext = createContext({
  isDark: false,
  setIsDark: () => {}
});

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(isDarkMode());

  useEffect(() => {
    const handleThemeChange = () => {
      setIsDark(isDarkMode());
    };

    window.addEventListener(CUSTOM_EVENTS.THEME_CHANGE, handleThemeChange);

    return () => {
      window.removeEventListener(CUSTOM_EVENTS.THEME_CHANGE, handleThemeChange);
    };
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
